<style lang="less" scoped>
  .login-center {
    background: #f5f5f5;
    height: 100%;
  }
  .login-box {
    background: #fff;
    width: 420px;
    margin: auto;
    padding-top: 10px;
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
    padding:25px 20px;
    .title {
      font-size: 20px;
      margin-bottom: 25px;
      color: #666;
    }
    .login {
      width: 120px;
      display: block;
      margin: auto;
      margin-bottom: 15px;
    }
  }
  .login-input {
    margin-bottom: 15px;
  }
</style>
<template>
  <div class="login-center">
    <Card class="login-box">
      <div style="text-align:center">
        <img class="login" src="assets/images/logo.png">
        <div class="title">为本为你 理所当然</div>
        <div class="login-input">
          <Input :disabled="load" type="number" size="large" v-model="phone" placeholder="登录账号" />
        </div>
        <div class="login-input">
          <Input :disabled="load" size="large" v-model="password" type="password" placeholder="登录密码" />
        </div>
        <div class="login-btn">
          <Button :loading="load" @click="login" size="large" type="primary" long>登录</Button>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
var that;
  import Store from 'store';
  import { POST } from "../plugins/core"; 
  export default {
    name: 'login',
    data() {
      return {
        load: false,
        phone: "",
        password: ""
      }
    },
    mounted() {
      that = this;
      if(Store.get('token')){
         that.$router.replace("/");
      }
    },
    methods: {
      login() {
        var phone = that.phone;
        var password = that.password;
        if (!phone) return that.$Message.error('请填写登录账号');
        if (!password) return that.$Message.error('请填写登录密码');
        that.load = true;
        POST('/adviserLogin', {
          phone,
          password
        }).then(function(res) {
          if (res.state !== 200) {
            that.load = false;
            return that.$Message.error(res.msg);
          }
          Store.set('token', res.data.token);
          Store.set('user', res.data.user);
          that.$router.replace("/");
        });
      }
    }
  }
</script>
